import React from 'react';
import { Modal, Button } from '@prosolve/common-components-ui'

// Close-only message box for actions the UI refuses (e.g. deleting a reserved folder). Same shell as
// UrlChangeConfirmationModal, but there is nothing to confirm, so the footer is a single Close.
export default ({
  title = 'Notice',
  message = '',
  closeLabel = 'Close',
  onClose
}) => {

  const footer = (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: '10px'
    }}>
      <Button onClick={onClose} $colored={true}>
        {closeLabel}
      </Button>
    </div>
  )

  return (
    <Modal title={title} isAutoHeight={true} closeOnOffClick={false} onClose={onClose} footer={footer}>
      <div>{message}</div>
    </Modal>
  )
}
